import React,{ Component } from 'react';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import Link from 'react-router-dom/NavLink';
import Redirect from 'react-router-dom/Redirect';

import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Container,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';


import Avatar from '../../../shared/components/Avatar';
import VersionTag from '../../../shared/components/VersionTag';
import NotificationTray from '../../../shared/components/NotificationTray';

// import Loading from '../Loading';
import AccountList from '../../AccountList';
import AccountView from '../../AccountView';
import AccountInfo from '../../AccountInfo';
import AccountNewIO from '../../AccountNewIO';
import AccountNewPaymentMethod from '../../AccountNewPaymentMethod';
import BrandList from '../../BrandList';
import BrandView from '../../BrandView';
import BrandInfo from '../../BrandInfo';
import ManageSuperUsers from '../../ManageSuperUsers';
import EditSuperUser from '../../EditSuperUser';
import ProviderCampaignList from '../../ProviderCampaignList';
import ProviderCampaignView from '../../ProviderCampaignView';
import ProviderSegmentationList from '../../ProviderSegmentationList';
import ProviderSegmentationInfo from '../../ProviderSegmentationInfo';
import ProviderConfiguration from '../../ProviderConfiguration';
import ProviderPromotions from '../../ProviderPromotions';
import GuidedCampaignCreation from '../../GuidedCampaignCreation';
import GuidedCampaignReview from '../../GuidedCampaignReview';
import GuidedCampaignPayment from '../../GuidedCampaignPayment';
import GuidedCampaignAudience from '../../GuidedCampaignAudience';

import { hideChatBox } from '../../../shared/utils';
import qs from "qs";

class ProviderPortal extends Component {
  constructor(){
    super();

    this.state = {
      open:false,
      isLoading:true,
      error:null
    };
  }

  componentDidMount(){
    const {
      loadActiveUser,
      ceaseImpersonation
    } = this.props;

    hideChatBox();

    Promise.all([
      loadActiveUser(),
      ceaseImpersonation()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch((err) => this.setState({error:err}));
  }

  componentDidUpdate(){
    hideChatBox();
  }

  handleSignOutClick(){
    const {
      invalidateAuthToken,
      invalidateImpersonateToken,
      history
    } = this.props;

    Promise.all([
      invalidateImpersonateToken(),
      invalidateAuthToken()
    ])
      .then(() => history.push('/login'))
      .catch((err) => this.setState({error:err}));
  }

  render(){
    const {
      isLoggedIn,
      activeUserName,
      activeUserAvatarURL,
      activeUserIsProvider,
      match,
      pathname,
      notifications,
      dismissNotification,
      environment,
      frontEndVersion,
      backEndVersion
    } = this.props;

    const brandId = qs.parse(this.props.location.search, { strictNullHandling: true, ignoreQueryPrefix: true  }).brandId;

    if(!isLoggedIn){
      return(
        <Redirect push
          to={{
            pathname:'/login',
            state:{
              from: pathname,
              message:''
            }
          }}
        />
      );
    }

    if(isLoggedIn && !activeUserIsProvider){
      return (
        <Redirect push
          to={{
            pathname:'/login',
            state: {
              from: pathname,
              message: 'The page you tried to access is for internal use only.  Please reauthenticate or contact Dabbl if you believe you are seeing this message in error.'
            }
          }}
        />
      )
    }

    return (
      <div className='ProviderPortal'>
        <VersionTag 
          environment={environment}
          frontend={frontEndVersion}
          backend={backEndVersion}
        />
        <Navbar
          light
          expand='xs'
          style={{
            padding:'0px 60px 0px 30px',
            color:'#101010',
            borderBottom:'1px solid #e4e4e4'
          }}
          className='HorizontalNavBar'
        >
          <Container>
            <NavbarBrand>
              <img
                src={require('../../../shared/assets/dabbl-logo.png')}
                alt='Dabbl'
                style={{
                  height:30,
                  marginRight:10
                }}
              />
              <span
                style={{
                  fontSize:14,
                  marginLeft:15,
                  color: 'rgba(0,0,0,.6)',
                  fontWeight:'bold'
                }}
              >
                SUPERADMIN
              </span>
            </NavbarBrand>
            <Collapse navbar isOpen>
              <Nav className='ml-auto' navbar>
                <NavItem className='NonUserNameNavItem'>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/accounts`}
                    activeClassName='active'
                  >
                    &nbsp;&nbsp;Accounts
                  </NavLink>
                </NavItem>
                <NavItem className='NonUserNameNavItem'>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/brands`}
                    activeClassName='active'
                  >
                    &nbsp;&nbsp;Brands
                  </NavLink>
                </NavItem>
                <NavItem className='NonUserNameNavItem'>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/experiences`}
                    activeClassName='active'
                  >
                    &nbsp;&nbsp;Experiences
                  </NavLink>
                </NavItem>
                <NavItem className='NonUserNameNavItem'>
                  <NavLink
                      tag={Link}
                      to={`${match.url}/promotions/verifiedpurchases`}
                      activeClassName='active'
                  >
                    &nbsp;&nbsp;Promotions
                  </NavLink>
                </NavItem>
                <NavItem className='NonUserNameNavItem'>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/configuration/distributions`}
                    activeClassName='active'
                  >
                    &nbsp;&nbsp;Configuration
                  </NavLink>
                </NavItem>
                <Dropdown
                  nav
                  inNavbar
                  isOpen={this.state.open}
                  toggle={() => this.setState({open:!this.state.open})}
                  className='UserNameNavItem'
                >
                  <DropdownToggle nav caret>
                    <Avatar
                      userName={activeUserName}
                      imageUrl={activeUserAvatarURL}
                    />
                    {/* <div className='UserName'>
                      {activeUserName[0].toUpperCase()}
                    </div> */}
                    &nbsp;&nbsp;
                  </DropdownToggle>
                  <DropdownMenu className='dropdown-menu-right'>
                    <DropdownItem
                      tag={Link}
                      exact
                      to={`${match.url}/profile`}
                    >
                      My Profile
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      exact
                      to={`${match.url}/superusers`}
                    >
                      Manage Team
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem
                      onClick={this.handleSignOutClick.bind(this)}
                    >
                      Sign Out
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem disabled>
                      Build {frontEndVersion}-{backEndVersion}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <NotificationTray
          notifications={notifications}
          onDismiss={(notificationId) => dismissNotification(notificationId)}
        />
        {/*HACK TO HIDE SUPPORT CHAT IN INTERNAL PORTAL*/}
        <div id='chat-widget'></div>
        {}
        <Container>
          <Switch>
            {/* BRAND ROUTES */}
            <Route path={`${match.url}/brands/new`} component={BrandInfo} />
            <Route path={`${match.url}/accounts/:accountId/brands/new`} component={BrandInfo} />
            {/*<Route path={`${match.url}/accounts/:accountId/billing/:historyId`} component={AccountNewIO} />*/}
            <Route path={`${match.url}/accounts/:accountId/paymentMethods/new`} component={AccountNewPaymentMethod} />
            <Route path={`${match.url}/brands/:brandId`} component={BrandView} />
            <Route path={`${match.url}/brands`} component={BrandList} />

            {/* ACCOUNT ROUTES */}
            <Route path={`${match.url}/accounts/new`} component={AccountInfo} />
            <Route path={`${match.url}/accounts/:accountId`} component={AccountView} />
            <Route path={`${match.url}/accounts`} component={AccountList} />
            <Route path={`${match.url}/agencies`} component={AccountList} />

            {/* SUPER USER ROUTERS */}
            <Route path={`${match.url}/superusers/new`} component={EditSuperUser} />
            <Route path={`${match.url}/superusers/:superuserId/edit`} component={EditSuperUser} />
            <Route path={`${match.url}/superusers`} component={ManageSuperUsers} />
            <Route path={`${match.url}/profile`} component={EditSuperUser} />
            <Route
              path={`${match.url}/tutorial/create/:campaignId`}
              render={(routeProps) => (
                <GuidedCampaignCreation
                  {...routeProps}
                  showSuperadminFeatures={true}
                  isOnboarding={false}
                  brandId={brandId}
                  forwardURL={`${match.url}/tutorial/audience/${routeProps.match.params.campaignId}${this.props.location.search}`}
                  backURL={brandId ? `${match.url}/brands/${brandId}/experiences`:`${match.url}/experiences`}
                />
              )}
            />
            <Route
              path={`${match.url}/tutorial/audience/:campaignId`}
              render={(routeProps) => (
                <GuidedCampaignAudience
                  {...routeProps}
                  showSuperadminFeatures={true}
                  isOnboarding={false}
                  forwardURL={`${match.url}/tutorial/review/${routeProps.match.params.campaignId}${this.props.location.search}`}
                  backURL={`${match.url}/tutorial/create/${routeProps.match.params.campaignId}${this.props.location.search}`}
                />
              )}
            />
            <Route
              path={`${match.url}/tutorial/payment/:campaignId`}
              render={(routeProps) => (
                <GuidedCampaignPayment
                  {...routeProps}
                  showSuperadminFeatures={true}
                  isOnboarding={false}
                  forwardURL={`${match.url}/tutorial/audience/${routeProps.match.params.campaignId}${this.props.location.search}`}
                  backURL={brandId ? `${match.url}/brands/${brandId}/experiences`:`${match.url}/experiences`}
                />
              )}
            />
            <Route
              path={`${match.url}/tutorial/review/:campaignId`}
              render={(routeProps) => (
                <GuidedCampaignReview
                  {...routeProps}
                  showSuperadminFeatures={true}
                  isOnboarding={false}
                  forwardURL={brandId ? `${match.url}/brands/${brandId}/experiences`:`${match.url}/experiences`}
                  backURL={`${match.url}/tutorial/audience/${routeProps.match.params.campaignId}${this.props.location.search}`}
                />
              )}
            />
            <Route path={`${match.url}/experiences/:campaignId`} component={ProviderCampaignView} />
            <Route path={`${match.url}/experiences`} component={ProviderCampaignList} />

            <Route path={`${match.url}/segmentations/new`} component={ProviderSegmentationInfo} />
            <Route path={`${match.url}/segmentations/:segmentationId/edit`} component={ProviderSegmentationInfo} />
            <Route path={`${match.url}/segmentations`} component={ProviderSegmentationList} />
            <Route path={`${match.url}/configuration`} component={ProviderConfiguration} />
            <Route path={`${match.url}/promotions`} component={ProviderPromotions} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default ProviderPortal;



// WEBPACK FOOTER //
// ./src/routes/ProviderPortal/components/ProviderPortal.js